import { FormGroup, FormParagraph, FormSection } from '@ksyos/design-system';
import type { IServiceOrganizationSettingFormSectionProps } from '../ServiceOrganizationSetting';
import { ServiceCode } from '../../../../../../common/enums/serviceCode';
import { translateKey } from '../../../../../translate';
import { InputTriState } from '../../../../elements/common';
import { ServiceOrganizationSettingFormMode } from '../ServiceOrganizationSetting';

interface IRecipientIsOwnOrganizationFormSectionProps extends IServiceOrganizationSettingFormSectionProps {
    hasServiceConsumers: boolean;
    hasServiceProviders: boolean;
}

export function RecipientIsOwnOrganizationFormSection(props: IRecipientIsOwnOrganizationFormSectionProps) {
    if (props.service.code !== ServiceCode.OSASV) {
        return null;
    }

    if (!props.hasServiceProviders || !props.hasServiceConsumers) {
        return null;
    }

    return (
        <FormSection title={translateKey('serviceTypeEnum.referralSmall')}>
            <FormGroup label={translateKey('addCarePathSettingsLabelsServiceConsumer.referralToSelf')}>
                {props.mode === ServiceOrganizationSettingFormMode.read ? (
                    <FormParagraph>
                        {props.recipientIsOwnOrganization ? translateKey('common.yes') : translateKey('common.no')}
                    </FormParagraph>
                ) : (
                    <InputTriState
                        fieldKey="recipientIsOwnOrganization"
                        notNullable
                    />
                )}
            </FormGroup>
        </FormSection>
    );
}
